import type { TableColumns, TableTagMappings } from '@ohpen/enso-ui';

import type { UserRow } from './interfaces';

export const SIGN_IN_LIST_NAME = 'configUserSignIns';
export const ROLES_LIST_NAME = 'configUserRoles';

export const userColumns: TableColumns<UserRow> = [
  {
    title: 'config.columns.name',
    dataIndex: 'name',
    key: 'name',
    width: 240,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.email',
    dataIndex: 'email',
    key: 'email',
    width: 300,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.signIn',
    dataIndex: 'signIn',
    key: 'signIn',
    width: 120,
    options: {
      format: { type: 'tag' },
      filter: 'select',
      listName: SIGN_IN_LIST_NAME,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  {
    title: 'config.columns.roles',
    dataIndex: 'roles',
    key: 'roles',
    options: {
      format: { type: 'multiTag' },
      filter: 'select',
      listName: ROLES_LIST_NAME,
      filterOptions: { allowedModes: ['anyMatches', 'exactMatch'] },
    },
  },
  {
    title: 'config.columns.created',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 140,
    options: { format: { type: 'date' }, sorter: true },
  },
];

export const getTagMappings = (): TableTagMappings => ({
  signIn: {
    sso: { color: 'blue' },
    credentials: { color: 'magenta' },
  },
});
